<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-link :to="{ name: 'MerchantsHostingPage-list' }">
            <feather-icon icon="ArrowLeftIcon" />
            <span class="align-middle ml-50">Back to List</span>
          </b-link>
        </b-col>
      </b-row>

      <b-card-header>
        <h3>Create New Merchant</h3>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="simpleRules">
          <form ref="form" @submit.stop.prevent="validationNewMerchantForm">
            <b-row>
              <b-col md="4">
                <b-form-group label="Merchant" label-for="Merchant">
                  <validation-provider #default="{ errors }" name="Merchant">
                    <b-form-select
                      id="Merchant-input"
                      v-model="newHosingPageMerchantFormData.MerchantId"
                      :options="merchants"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Header Color" label-for="HeaderColor">
                  <validation-provider #default="{ errors }" name="HeaderColor">
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="HeaderColor-input"
                      v-model="newHosingPageMerchantFormData.HeaderColor"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Text Color" label-for="TextColor">
                  <validation-provider #default="{ errors }" name="TextColor">
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="TextColor-input"
                      v-model="newHosingPageMerchantFormData.TextColor"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Button Color" label-for="ButtonColor">
                  <validation-provider
                    #default="{ errors }"
                    name="ButtonColor"
                    rules="required"
                  >
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="ButtonColor-input"
                      v-model="newHosingPageMerchantFormData.ButtonColor"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Background Color"
                  label-for="BackgroundColor"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="BackgroundColor"
                    rules="required"
                  >
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="BackgroundColor-input"
                      v-model="newHosingPageMerchantFormData.BackgroundColor"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Title Name" label-for="TitleName">
                  <validation-provider
                    #default="{ errors }"
                    name="TitleName"
                    rules="required"
                  >
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="TitleName-input"
                      v-model="newHosingPageMerchantFormData.TitleName"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Title Color" label-for="TitleColor">
                  <validation-provider
                    #default="{ errors }"
                    name="TitleColor"
                    rules="required"
                  >
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="TitleName-input"
                      v-model="newHosingPageMerchantFormData.TitleColor"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Image" label-for="ImageURL">
                  <validation-provider #default="{ errors }" name="imageURL">
                    <b-form-file
                      id="file-default"
                      v-model="newHosingPageMerchantFormData.file"
                      :state="errors.length > 0 ? false : null"
                      accept="image/jpeg, image/png"
                    ></b-form-file>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <br />
            <br />
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="validationNewMerchantForm"
            >
              Save
            </b-button>
          </form>
        </validation-observer>
      </b-card-body>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BCard,
  BButton,
  BFormCheckbox,
  BCardBody,
  BCardHeader,
  BFormSelect,
  BOverlay,
  BLink,
  BFormFile,
} from "bootstrap-vue";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import vSelect from "vue-select";

import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BCard,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    AppCollapse,
    AppCollapseItem,
    BCardBody,
    BCardHeader,
    vSelect,
    BOverlay,
    BLink,
    BFormFile,
  },
  data() {
    return {
      required,
      isLoading: false,
      newHosingPageMerchantFormData: {
        MerchantId: null,
        HeaderColor: "",
        TextColor: "",
        ButtonColor: "",
        BackgroundColor: "",
        TitleName: "",
        TitleColor: "",
        file: null,
      },
      selectedMerchantName: "",
      users: [],
      selelctedLevels: [],
      merchants: [],
    };
  },
  created() {
    this.fetchData();
  },
  destroyed() {},
  methods: {
    isLetterandNumber(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z0-9_.,\s#]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    validationNewMerchantForm() {
      console.log(this.newHosingPageMerchantFormData);
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.isLoading = true;
          const formData = new FormData();
          Object.keys(this.newHosingPageMerchantFormData).forEach((key) => {
            const value = this.newHosingPageMerchantFormData[key];
            formData.append(key, value);
          });

          axios
            .post("/Merchant/api/V1.0/Merchants/AddMerchantDetail", formData, {
              headers: {
                "Content-Type":
                  "multipart/form-data; boundary=<calculated when request is sent>",
                Accept: "application/javascript",
              },
            })
            .then((res) => {
              console.log(this.newHosingPageMerchantFormData);
              this.isLoading = false;
              this.$bvModal
                .msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then((result) => {
                  if (result) {
                    this.$router.push({ name: "MerchantsHostingPage-list" });
                  }
                });
            })
            .catch((res) => {
              this.isLoading = false;
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Merchants-View");
      axios
        .get("/Merchant/api/V1.0/Merchants/GetMerchants")
        .then((res) => {
          res.merchants.forEach((item) => {
            this.merchants.push({
              value: item.id,
              text: item.name,
            });
          });
          // res.users.filter(f => f.accessType === 1).forEach(item => {
          //   this.users.push({
          //     value: item.id,
          //     text: item.username,
          //   })
          // })
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
